import classNames from 'classnames/bind';
import { Popup as SemanticPopup, PopupProps } from 'semantic-ui-react';
import styles from './Popup.module.scss';

const cx = classNames.bind(styles);

const Popup = ({
  className,
  offset = [0, 4],
  basic = true,
  closeOnEscape = true,
  position = 'bottom right',
  ...rest
}: PopupProps): React.ReactElement => {
  return (
    <SemanticPopup
      offset={offset}
      basic={basic}
      position={position}
      closeOnEscape={closeOnEscape}
      className={cx('body', className)}
      {...rest}
    />
  );
};

export default Popup;
